import { render, staticRenderFns } from "./ConfigSettings.vue?vue&type=template&id=dbc9163a&"
import script from "./ConfigSettings.vue?vue&type=script&lang=js&"
export * from "./ConfigSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports